import {
  AssetSupplier,    SaveSupplierData,
  SaveSupplierResult,
  PayloadApiResponse,
} from '@portal-workspace/grow-shared-library';
import {Observable,  } from 'rxjs';
import { Address2ComponentValue } from '@portal-workspace/grow-shared-library';


export type SearchSupplierFn = (abn: string, accreditedOnly?: boolean)=> Observable<AssetSupplier[]>;
export type SaveSupplierFn = (supplier: SaveSupplierData) => Observable<PayloadApiResponse<SaveSupplierResult>>;

export interface PpsrAssetSupplierSearchEvent {
  type: 'submitForAccreditation',
  supplierType: string,
  supplierName: string,
  abn: string;
  address: Address2ComponentValue,
  contact: string;
}
